import axiosClient from "../../../../system/helpers/axiosConfig";

export const postLandingPage = (params) => {
  return axiosClient
    .post(`api/admin/landing-pages/update`, params)
    .then((r) => r.data.data);
};
